export const RECOMMENDATION_ITEM_WIDTH = {
    mobile: '80vw',
    mobileMedium: '80vw',
    mobileWide: '300px',
};
